module.exports = __webpack_public_path__ + "static/media/music_accessories_dark.b98e2bad.svg";